// Permisos RBAC de la pantalla Cobranza. Están ENCENDIDOS: los endpoints del lambda los exigen con
// scope TENANT, así que sin ellos la pantalla se esconde (fail-closed) — eso es correcto, no un bug.

/**
 * Claves de permiso del dominio de cobranza. Van como `string` y no como `Permission` porque
 * `PermissionKey` (generado del OpenAPI del rbac) hoy no expone ninguna clave de dominio.
 */
export const COLLECTIONS_PERMISSIONS = {
    readAssignments: 'loan.collectorAssignment.read',
    reassign: 'loan.collectorAssignment.reassign',
    redistribute: 'loan.collectorAssignment.redistribute',
    readRules: 'loan.assignmentRule.read',
    createRule: 'loan.assignmentRule.create',
    updateRule: 'loan.assignmentRule.update',
} as const;

export type CollectionsPermissionKey =
    (typeof COLLECTIONS_PERMISSIONS)[keyof typeof COLLECTIONS_PERMISSIONS];

/** El gate está encendido: sin la clave la pantalla se esconde (fail-closed). */
export const COLLECTIONS_PERMISSIONS_ENFORCED = true;

export interface CollectionsAbilities {
    canReadAssignments: boolean;
    canReassign: boolean;
    canRedistribute: boolean;
    canReadRules: boolean;
    canCreateRule: boolean;
    canUpdateRule: boolean;
}

/** Con `enforce: false` todo queda permitido; con `true` cada acción exige su clave. */
export function resolveCollectionsAbilities(
    grantedPermissions: ReadonlySet<string>,
    enforce: boolean = COLLECTIONS_PERMISSIONS_ENFORCED,
): CollectionsAbilities {
    if (!enforce) {
        return {
            canReadAssignments: true,
            canReassign: true,
            canRedistribute: true,
            canReadRules: true,
            canCreateRule: true,
            canUpdateRule: true,
        };
    }
    return {
        canReadAssignments: grantedPermissions.has(COLLECTIONS_PERMISSIONS.readAssignments),
        canReassign: grantedPermissions.has(COLLECTIONS_PERMISSIONS.reassign),
        canRedistribute: grantedPermissions.has(COLLECTIONS_PERMISSIONS.redistribute),
        canReadRules: grantedPermissions.has(COLLECTIONS_PERMISSIONS.readRules),
        canCreateRule: grantedPermissions.has(COLLECTIONS_PERMISSIONS.createRule),
        canUpdateRule: grantedPermissions.has(COLLECTIONS_PERMISSIONS.updateRule),
    };
}
